module.exports = __webpack_public_path__ + "img/miracle.b5252e93.png";